import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import * as courseAPI from "../../api/course";

const initialState = {
  data: [],
  activeCourse: null,
  activeData: null,
  department: [],
  program: [],
  loading: false,
  perPage: 10,
  page: 1,
  offset: 0,
};

const getAllCourse = createAsyncThunk(
  "course/getAllCourse",
  async (params, { rejectWithValue }) => {
    try {
      const res = await courseAPI.getCourse(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const addCourse = createAsyncThunk(
  "course/addCourse",
  async (params, { rejectWithValue }) => {
    try {
      const res = await courseAPI.addCourse(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const getProgram = createAsyncThunk(
  "course/getProgram",
  async (params, { rejectWithValue }) => {
    try {
      const res = await courseAPI.getProgram(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const getDepartment = createAsyncThunk(
  "course/getDepartment",
  async (params, { rejectWithValue }) => {
    try {
      const res = await courseAPI.getDepartment(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const updateCourse = createAsyncThunk(
  "course/updateCourse",
  async (params, { rejectWithValue }) => {
    try {
      const res = await courseAPI.updateCourse(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const deleteCourse = createAsyncThunk(
  "course/delete",
  async (params, { rejectWithValue }) => {
    try {
      const res = await courseAPI.deleteCourse(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const courseSlice = createSlice({
  name: "course",
  initialState: initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    getActiveCourse: (state, action) => {
      state.activeCourse = action.payload;
      state.activeData = state.data?.course?.filter(
        (_el) => _el.id === action.payload
      );
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setOffset: (state, action) => {
      state.offset = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
  },
  extraReducers: {
    [getAllCourse.pending]: (state) => {
      state.loading = true;
    },
    [getAllCourse.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    [getAllCourse.rejected]: (state) => {
      state.loading = false;
      state.data = [];
    },

    [addCourse.pending]: (state) => {
      state.loading = true;
    },
    [addCourse.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [addCourse.rejected]: (state, action) => {
      state.loading = false;
      //console.log("addCourse", action.payload);
      toast.error(action.payload);
    },

    [getProgram.pending]: (state) => {
      state.loading = true;
    },
    [getProgram.fulfilled]: (state, action) => {
      state.loading = false;
      state.program = action.payload;
    },
    [getProgram.rejected]: (state) => {
      state.loading = false;
    },

    [getDepartment.pending]: (state) => {
      state.loading = true;
    },
    [getDepartment.fulfilled]: (state, action) => {
      state.loading = false;
      state.department = action.payload;
    },
    [getDepartment.rejected]: (state) => {
      state.loading = false;
    },

    [updateCourse.pending]: (state) => {
      state.loading = true;
    },
    [updateCourse.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [updateCourse.rejected]: (state, action) => {
      state.loading = false;
    },

    [deleteCourse.pending]: (state) => {
      state.loading = true;
    },
    [deleteCourse.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [deleteCourse.rejected]: (state, action) => {
      state.loading = false;
    },
  },
});

const { resetState, getActiveCourse,
  setPerPage,
  setOffset,
  setPage, } = courseSlice.actions;
export default courseSlice.reducer;
export {
  resetState,
  getAllCourse,
  getDepartment,
  getProgram,
  addCourse,
  updateCourse,
  getActiveCourse,
  deleteCourse,

  setPerPage,
  setOffset,
  setPage,
};
